<phito-key-value-list title="Wartungen & Aufgaben">
    @for (maintenance of maintenances(); track maintenance.id) {
    <phito-key-value-list-item icon="hardware" [key]="maintenance.maintenanceNo ?? 'Maintenance'"
        [value]="maintenance.title" actionButtonIcon="open_in_new" (actionClicked)="goToMaintenance(maintenance)">
    </phito-key-value-list-item>
    }
</phito-key-value-list>